<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Motor Accident
        div.small.text-muted
          | Displaying motor accidents reported
      div.col-sm-7.hidden-sm-down
        b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br
    crm-table-appointment
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/CRM/appointment.vue?48301366